import type { Airport } from "@jetblue/fuzzy-search";
import { useMemo } from "react";

const indexAirportsByCode = (airports: Airport[]) => {
  const map = new Map<string, Airport>();

  const walk = (list: Airport[]) => {
    for (const a of list) {
      map.set(a.code, a);
      if (a.cc?.length) {
        walk(a.cc);
      }
    }
  };

  walk(airports);
  return map;
};

export const useAirportNameMap = (airports: Airport[]) =>
  useMemo(() => indexAirportsByCode(airports), [airports]);
